import {formatarData} from '../processo/processoSelecao.js';
import {ouTraco} from '../inscricao/documentoInscricao.js';

/*
 * Regras puras da tela Enviar E-mails do administrativo (módulo RCENVEMAIL): textos,
 * formatação das colunas, regras de habilitação dos botões e corpo enviado ao back.
 */

export const SEM_REGISTROS_INSCRITOS = 'Nenhum inscrito encontrado.';
export const TITULO_PREVIA_EMAIL = 'Prévia do E-mail';
export const TITULO_RESULTADO_ENVIO = 'Resultado do Envio';

export const confirmacaoEnvio = quantidade => `Tem certeza que deseja enviar e-mails para ${quantidade} inscrito(s)?`;

export const mensagemEnvioSucesso = quantidade => `E-mail enviado para ${quantidade} inscrito(s).`;

export const resumoResultadoEnvio = (enviados, falhas) => `${enviados} e-mail(s) enviado(s) e ${falhas} falha(s).`;

const preenchido = valor => valor !== null && valor !== undefined && String(valor).trim() !== '';

/* "Nome (Nome Social)"; só o nome quando não há nome social. */
export const formatarNomeComSocial = (nome, nomeSocial) => {
    if (!preenchido(nome)) {
        return preenchido(nomeSocial) ? String(nomeSocial).trim() : ouTraco('');
    }

    return preenchido(nomeSocial) ? `${String(nome).trim()} (${String(nomeSocial).trim()})` : String(nome).trim();
};

/* Data do último envio (yyyy-MM-dd) em dd/MM/yyyy ou "-". */
export const formatarDataEnvio = valor => formatarData(valor);

/* Quantidade de envios (número) ou "-" quando nula. */
export const formatarQuantidadeEnvios = valor => ouTraco(valor);

/* Opção de situação que não tem modelo de e-mail fica desabilitada. */
export const situacaoDesabilitada = situacao => !situacao || situacao.possuiModelo === false;

/* Situação (código) escolhida entre as opções que têm modelo. */
export const situacaoComModelo = (situacoes, codigo) =>
    (Array.isArray(situacoes) ? situacoes : []).some(item => item.codigo === codigo && item.possuiModelo !== false);

/* Visualizar a prévia: processo e situação com modelo escolhidos. */
export const podeVisualizar = ({idProcessoSelecao, situacao, situacoes}) =>
    preenchido(idProcessoSelecao) && preenchido(situacao) && situacaoComModelo(situacoes, situacao);

/* Enviar: ao menos um inscrito marcado e nada em andamento. */
export const podeEnviar = ({idProcessoSelecao, situacao, selecionados, ocupado = false}) =>
    !ocupado && preenchido(idProcessoSelecao) && preenchido(situacao)
    && Array.isArray(selecionados) && selecionados.length > 0;

/* Parâmetros do GET /inscricoes e do GET /modelo. */
export const montarParametrosEnvio = ({idProcessoSelecao, situacao}) => ({
    idProcessoSelecao: Number(idProcessoSelecao),
    situacao
});

/* Corpo do POST de envio. */
export const montarPayloadEnvio = ({idProcessoSelecao, situacao, selecionados}) => ({
    idProcessoSelecao: Number(idProcessoSelecao),
    situacao,
    idsInscricoes: (selecionados || []).map(inscricao => inscricao.id)
});

/* Falhas do envio com a chave que o DataGrid exige por linha. */
export const comChaveFalhas = falhas => (Array.isArray(falhas) ? falhas : [])
    .map((falha, indice) => ({...falha, chave: `${falha.idInscricao}-${indice}`}));
